export default __webpack_public_path__ + "static/media/CEM-Title-Image.a8e337af.webp";